import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class Multiselect extends Vue {
  // Valores posibles
  @Prop({ default: () => [] }) values;

  // Display property to show. If null, root value will be displayed.
  @Prop({ default: "name" }) displayProperty!: string;

  @Prop({ default: null }) selectedValue;
  // Mensaje en caso de no haber seleccionado una opción
  @Prop({ default: "Selecciona una opción" }) placeholder;

  @Prop({ default: true }) isRounded;
  @Prop({ default: false }) isError;
  @Prop({ default: false }) isDisabled;
  @Prop({ default: null }) width;

  openSelector = false;

  toggleOpenSelector() {
    if (!this.isDisabled) {
      this.openSelector = !this.openSelector;
    }
  }

  getValue(option) {
    if (this.displayProperty) return option[this.displayProperty];
    return option;
  }

  setCurrentValue(option) {
    if (!this.isDisabled) {
      this.openSelector = false;
      this.$emit("on-select-value", option);
    }
  }
}
